var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":"图片收藏夹","placement":"bottom"}},[_c('i',{staticClass:"el-icon-star-off d2-mr btn-text can-hover",staticStyle:{"font-size":"20px"},on:{"click":_vm.openImageFavorite}})])
}
var staticRenderFns = []

export { render, staticRenderFns }